var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fields',{attrs:{"fields":_vm.interfaceFields,"disabled":_vm.disabled},model:{value:(_vm.data.args),callback:function ($$v) {_vm.$set(_vm.data, "args", $$v)},expression:"data.args"}}),_vm._v(" "),_c('submit-field',{attrs:{"disabled":_vm.disabled || !_vm.editable || !_vm.isValid},on:{"click":_vm.submit}},[_vm._v("确定")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57616616","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/vue-form.vue
// module id = null
// module chunks = 